export const userRoleToText = {
  admin: 'Администратор',
  client: 'Заказчик',
  dispatcher: 'Диспетчер',
  owner: 'Владелец техники',
  user: 'Заказчик',
  driver: 'Водитель',
}
